/* eslint-disable no-template-curly-in-string */
/* eslint-disable no-loop-func */
import React from 'react';
import { createContext, useContext } from 'react';
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import _ from 'lodash';

import { axios } from '../../../../../v5/utils/axios';
import { success, successAPI, errorAPI, getMaxPageSize, getCurrency, formatNumber, isNumeric } from '../../../../../v5/utils/utils';
import Yup from '../../../../../v5/utils/yup';
import { ProformaInvoiceStatus } from '../../../../../v5/utils/enums';

import { getTotal, fields as proformaFields } from "../proformaInvoice/slice.tsx";
// import { isStandardService } from '../../slice.tsx';


export const totalFields = {
  subtotal: {
    id: 'subtotal',
    label: 'Subtotal',
    placeholder: '',
  },
  GSTTotal: {
    id: 'GSTTotal',
    label: 'GST Total',
    placeholder: '',
  },
  total: {
    id: 'total',
    label: 'Total',
    placeholder: '',
  },
  paymentReceived: {
    id: 'paymentReceived',
    label: 'Payment received',
    placeholder: '',
  },
  balance: {
    id: 'balance',
    label: 'Balance',
    placeholder: '',
  },
};

export const fields = {
  jobNumber: {
    id: 'jobNumber',
    label: 'DO#',
    placeholder: '',
  },
  customerName: {
    id: 'customerName',
    label: 'Customer name',
    placeholder: '',
  },
  isBillable: {
    id: 'isBillable',
    label: 'Status',
    placeholder: '',
    optionBillable: 'Billable',
    optionNonBillable: 'Non Billable',
  },

  proformaInvoiceDate: {
    id: 'proformaInvoiceDate',
    label: 'Proforma Date',
    placeholder: 'Date',
  },
  proformaInvoiceNumber: {
    id: 'proformaInvoiceNumber',
    label: 'Proforma number',
    placeholder: '',
  },
  proformaInvoiceStatus: {
    id: 'proformaInvoiceStatus',
    label: 'Proforma Status',
    placeholder: 'Select',
  },

  accountBillingProfileId: {
    id: 'accountBillingProfileId',
    label: 'Billing by',
    placeholder: 'Billing by',
  },
  billingAddress: {
    id: 'billingAddress',
    label: 'Billing address',
    placeholder: 'Address',
  },
  invoiceDate: {
    id: 'invoiceDate',
    label: 'Invoice date',
    placeholder: 'Date',
  },
  billedDate: {
    id: 'billedDate',
    label: 'Billed date',
    placeholder: 'Date',
  },
  paymentTermsId: {
    id: 'paymentTermsId',
    label: 'Payment terms',
    placeholder: 'Payment terms',
  },
  xeroPaymentTerm: {
    id: 'xeroPaymentTerm',
    label: 'Payment terms',
    placeholder: 'Payment terms',
  },
  billingNote: {
    id: 'billingNote',
    label: 'Billing note',
    placeholder: 'Notes',
  },
  invoiceNumber: {
    id: 'invoiceNumber',
    label: 'Invoice number',
    placeholder: 'Invoice number',
  },

  serviceTag: {
    id: 'serviceTag',
    label: 'Service name',
    placeholder: '',
  },
  billingType: {
    id: 'billingType',
    label: 'Billing action',
    placeholder: '',
  },
  chargeCategoryId: {
    id: 'chargeCategoryId',
    label: 'Billing category',
    placeholder: '',
  },
  quantity: {
    id: 'quantity',
    label: 'Quantity',
    placeholder: '',
  },
  price: {
    id: 'price',
    label: 'Rate',
    placeholder: '',
  },
  total: {
    id: 'total',
    label: 'Total',
    placeholder: '',
  },
  delete: {
    id: 'delete',
    label: 'Delete',
    placeholder: '',
  },
  rate: {
    id: 'rate',
    label: 'Rate',
    placeholder: '',
  },
  additionalServices: {
    id: 'rate',
    label: 'Additional Services',
    placeholder: '',
  }
};

export const formSchema = () => {
  return Yup.object().shape({
    isBillable: Yup.bool().oneOf([true, false]).label(fields.isBillable.label),
    
    billedDate: Yup.string().nullable().label(fields.billedDate.label),
    invoiceDate: Yup.string().nullable().label(fields.invoiceDate.label),
    invoiceNumber: Yup.string().nullable().label(fields.invoiceNumber.label),
    accountBillingProfileId: Yup.number().nullable().label(fields.accountBillingProfileId.label),
    paymentTermsId: Yup.number().nullable().label(fields.paymentTermsId.label),
    xeroPaymentTerm: Yup.number().nullable().positive().min(0).label(fields.xeroPaymentTerm.label),
    billingAddress: Yup.string().nullable().label(fields.billingAddress.label),
    billingNote: Yup.string().nullable().label(fields.billingNote.label),

    tab: Yup.string(),
    pricings: Yup.array().when(['isBillable', 'tab'], ([isBillable, tab]) => {
      if(tab === 'tab2'){
        return formSchemaPricings(isBillable);
      } else {
        return formSchemaPricings(false);
      }
    })
    .hasEmpty('serviceTag', 'There are empty fields'),


    proformaInvoiceDate: Yup.string().nullable().label(fields.proformaInvoiceDate.label),
    proformaInvoiceNumber: Yup.string().nullable().label(fields.proformaInvoiceNumber.label),
    proformaInvoiceStatus: Yup.number().nullable().label(fields.proformaInvoiceStatus.label),
    proformaInvoiceTotal: Yup.number().nullable().min(0).label(proformaFields.proformaInvoiceTotal.label),
    proformaPaymentMethodMetaId: Yup.number().nullable().min(0).label(proformaFields.proformaPaymentMethodMetaId.label),
    proformaPaymentType: Yup.number().nullable().min(0).label(proformaFields.proformaPaymentType.label),
    proformaPaymentReceived: Yup.number().nullable().min(0).label(proformaFields.proformaPaymentReceived.label),

    proformaPricings: Yup.array().when(['isBillable', 'tab'], ([isBillable, tab]) => {
      if(tab === 'tab1'){
        return formSchemaPricings(isBillable);
      } else {
        return formSchemaPricings(false);
      }
    })
    .hasEmpty('serviceTag', 'There are empty fields')
  })
}
export const formSchemaPricings = (isBillable: boolean = false) => {
  if (isBillable) {
    return Yup.array().of(Yup.object().shape({
      serviceTag: Yup.string().required().label(fields.serviceTag.label),
      billingType: Yup.number().nullable().label(fields.billingType.label),
      chargeCategoryId: Yup.number().min(0).nonNullable().required().label(fields.chargeCategoryId.label),
      quantity: Yup.number().nullable().min(0).label(fields.quantity.label),
      price: Yup.number().nullable().label(fields.price.label),
    })).customValidation(useBinWeightQuantityValidation);
  } else {
    return Yup.array().of(Yup.object().shape({
      serviceTag: Yup.string().label(fields.serviceTag.label),
      billingType: Yup.number().nullable().label(fields.billingType.label),
      chargeCategoryId: Yup.number().nullable().label(fields.chargeCategoryId.label),
      quantity: Yup.number().nullable().min(0).label(fields.quantity.label),
      price: Yup.number().nullable().label(fields.price.label),
    }));
  }
}
export const useBinWeightQuantityValidation = (values: any) => {
  let isValid = false;
  let error = '';

  let pricings = (values && values.length > 0) ? values : [];

  if(pricings && pricings.length > 0){
    let useBinWeight = pricings.filter((item: any) => item.useBinWeightQuantity == true)

    if(useBinWeight && useBinWeight.length > 1){
      isValid = false;
      error = 'Only one item can have Bin Weight linked as Quantity';
    } else {
      isValid = true;
    }
  } else {
    isValid = true;
  }
  
  return {
    isValid: isValid,
    error: error,
  };
}


let formikContext: any = null;
export const FormikContext = createContext<any>(null);
export const useFormikContext = () => {
    formikContext = useContext(FormikContext);
    if (!formikContext) {
      throw new Error('useFormikContext must be used within a FormikProvider');
    }
    return formikContext;
};


export const prepareData = (values: any = null) => {
  let data: any = {};

  let form = _.cloneDeep(values);

  if(form){
    data['isBillable'] = form.isBillable;
    data['invoiceDate'] = form.invoiceDate;
    data['billingNote'] = form.billingNote;
    data['pricings'] = form.pricings;

    data['proformaInvoiceTotal'] = form.proformaInvoiceTotal;
    data['proformaPaymentMethodMetaId'] = form.proformaPaymentMethodMetaId;
    data['proformaPaymentMethodMetaName'] = form.proformaPaymentMethodMetaName;
    data['proformaPaymentType'] = form.proformaPaymentType;
    data['proformaPaymentReceived'] = form.proformaPaymentReceived;
    data['proformaInvoiceStatus'] = form.proformaInvoiceStatus;
    data['proformaInvoiceDate'] = form.proformaInvoiceDate;
    data['proformaInvoiceNumber'] = form.proformaInvoiceNumber;
    data['proformaPricings'] = form.proformaPricings;

    let field = (form?.proformaInvoiceNumber && form?.proformaInvoiceNumber != '') ? 'proformaPricings' : 'pricings';
    let totalObj = getTotal(form, [], field);
    let balance: any = totalObj?.balance.toFixed(2) || 0;
    data['amountToCollect'] = (form?.proformaInvoiceNumber && form?.proformaInvoiceNumber != '') ? form.proformaInvoiceTotal : balance;
  }

  return data;
};


export const getBillingTypeName = (billingType: number|null) => {
  if(billingType === BillingTypes.Expense){
    return 'Expense';
  } else if(billingType === BillingTypes.Purchase){
    return 'Purchase';
  } else if(billingType === BillingTypes.Invoice){
    return 'Invoice';
  } else {
    return '';
  }
}

export const getProformaInvoiceStatusList = (values: any, justPaid: boolean = false) => {
  let paid = '';

  if(justPaid){
    paid = 'PAID';
  } else {
    let price = values?.proformaPaymentReceived || 0;
    
    let totalObj = getTotal(values, [], 'proformaPricings');
    let balance: any = totalObj?.balance.toFixed(2) || 0;

    if(parseFloat(price) < parseFloat(balance)){
      paid =  'PARTIAL (' + getCurrency() + formatNumber(price) + ')';
    } else {
      paid =  'FULLY PAID';
    }
  }

  return [
    {
      value: ProformaInvoiceStatus.Draft,
      label: 'DRAFT',
      className: 'gray-500',
    },
    {
      value: ProformaInvoiceStatus.Sent,
      label: 'SENT',
      className: 'yellow-500',
    },
    {
      value: ProformaInvoiceStatus.Accepted,
      label: 'ACCEPTED',
      className: 'purple-500',
    },
    {
      value: ProformaInvoiceStatus.Declined,
      label: 'DECLINED',
      className: 'red-500',
    },
    {
      value: ProformaInvoiceStatus.Paid,
      label: paid,
      className: 'green-500',
    }
  ];
}


export const ServiceType = {
  StandardService: 0,
  BundleService: 1,
  AdditionalService: 2
}

export const BillingTypes = {
  Invoice: 0,
  Purchase: 1,
  Expense: 2
}


export interface pricingsItemStruct {
  serviceType: number|null,

  serviceItemId: number|null,
  serviceTag: string,
  serviceItem: number|null,

  billingType: number|null,
  
  chargeCategoryId: number|null,
  chargeCategoryName: string,
  chargeCategory: number|null,

  quantity: number|null,
  price: number|null,
}
export const initPricingsItem: pricingsItemStruct = {
  serviceType:  ServiceType.AdditionalService,

  serviceItemId: null,
  serviceTag: '',
  serviceItem: null,

  billingType: BillingTypes.Invoice,

  chargeCategoryId: null,
  chargeCategoryName: '',
  chargeCategory: null,

  quantity: null,
  price: null,
}


export const initialValues: any = {
  isBillable: false,
  pricings: [],
};


interface InitState {
  show: boolean,
  form: any,
  tab: string,

  isLoadingUpdateBilling: boolean,
  listUpdateBilling: Array<any>,
}

function NewReducer() {
  const name = 'jobFormBillingJobSlice';


  const initialState: InitState = {
    show: false,
    form: null,
    tab: 'tab1',

    isLoadingUpdateBilling: false,
    listUpdateBilling: [],
  };


  const reducers = {
    resetSlice: () => {
      return initialState;
    },
    setShow: (state: InitState, action: PayloadAction<{ show: boolean, form: any }>) => {
      state.show = action.payload.show;
      state.form = action.payload.form;
    },
    setTab: (state: InitState, action: PayloadAction<string>) => {
      state.tab = action.payload;
    },
    setLoading: (state: InitState, action: PayloadAction<boolean>) => {
      state.isLoadingUpdateBilling = action.payload;
    },

    startUpdateBilling: (state: InitState) => {
      state.isLoadingUpdateBilling = true;
      state.listUpdateBilling = [];
    },
    finishUpdateBilling: (state: InitState, action: PayloadAction<any>) => {
      let data = (action.payload && action.payload.data && action.payload.data.length > 0) ? action.payload.data : [];
      state.listUpdateBilling = data;
      state.isLoadingUpdateBilling = false;
    },
  };


  const apis = {
    callUpdateBillingApi: ({ customerId = null, customerSiteId = null }: any, callback: (state: boolean, data: any) => void) => async (dispatch: any) => {
      dispatch(actions.startUpdateBilling());

      let params = {
        currentPage: 1,
        pageSize: getMaxPageSize(),
        // searchQuery: '',
        // sortColumn: 'serviceTag',
        // sortDir: 'desc',
        includeGlobalService: true,
        includeTaxRate: true,
        customerId: customerId,
        customerSiteId: customerSiteId,
      };

      await axios.get('service-item', { params: params }).then((result: any) => {
        let data = result.data;
        
        successAPI(data);

        callback(true, data);
        dispatch(actions.finishUpdateBilling(data));
      }).catch((error: any) => {
        errorAPI(error);
        
        callback(false, null);
        dispatch(actions.finishUpdateBilling(null));
      });
    },
  };


  const { reducer, actions } = createSlice({
    name,
    initialState,
    reducers,
  });


  return {
    reducer,
    ...actions,
    ...apis,
  };
}


export default NewReducer();